import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { StaticValueService } from '../../../shared/services/static-value.service';

@Component({
    selector: 'app-address-format-input',
    templateUrl: './address-format-input.component.html',
    styleUrls: ['./address-format-input.component.scss']
})
export class AddressFormatInputComponent implements OnInit, OnChanges {
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() sameasPA: EventEmitter<any> = new EventEmitter<any>();
  @Input() field: string;
  @Input() country: string;
  @Input() mode: string;
  @Input() fieldDisplayName: string;
  @Input() sameAsTA: Boolean;
  @Input() displayIcon: Boolean = false;
  @Input()  taxAddressObject: any; // for prefilling the personal Address fields with taxAddress Values
  @Input() addressObject = {
    'address1': '',
    'address2': '',
    'address3': '',
    'city': '',
    'state': '',
    'zip': '',
    'country': ''
  };
  public dummyTestBindingVariable;
  public dummyTestBindingArr = {};
  public staticDDlist;
  public sameAsTaxAddress:Boolean = false;
  public addressFormatObject = {}
  public addressDisplayArray= [];
  private addressObjectcopy: any;

  transform( country ): any {
    const stringToReturnAddress = '';
    function compare(a, b) {
      if (a.order < b.order) {
        return -1;
        }
      if (a.order > b.order) {
         return 1; }
      return 0;
    }
        // default case
        this.addressDisplayArray = [];
        if (country === '' || country === undefined || this.addressFormatObject[country] == undefined) {
            country = 'default';
        }
        for (let fieldDisplayObject in this.addressFormatObject[country]) {
            if (this.addressFormatObject[country].hasOwnProperty(fieldDisplayObject)) {
                if (this.addressFormatObject[country][fieldDisplayObject]['visibility'] === true) {
                    let temp = {
                        'visibility': true,
                        'fieldName': this.addressFormatObject[country][fieldDisplayObject]
                    }
                    this.addressDisplayArray.push(temp)
                } else {
                    let temp = {
                        'visibility': false,
                        'fieldName': this.addressFormatObject[country][fieldDisplayObject]
                    }
                    this.addressDisplayArray.push(temp)
                }
            }
        }
        this.addressDisplayArray.sort(compare);
    }

    getFieldFromAddressObjectIndex(addrssObj, arrayObject, country) {
        return addrssObj[arrayObject.fieldName];
    }

    constructor(public staticDDlistService: StaticValueService) { }

  ngOnInit() {
    this.staticDDlist = this.staticDDlistService.staticData.staticDD;
    this.addressFormatObject = JSON.parse(JSON.stringify(this.staticDDlist.addressFormats));
    this.addressDisplayArray = [{'visibility': true,
    'fieldName': 'address1',
    'displayName': 'Address 1' } ,
    {'visibility': true,
    'fieldName': 'address2',
    'displayName': 'Address 2' },
    {'visibility': true,
    'fieldName': 'address3',
    'displayName': 'Address 3' },
    {'visibility': true,
    'fieldName': 'city',
    'displayName': 'City' },
     {'visibility': true,
    'fieldName': 'zip',
    'displayName': 'Zip' },
    {'visibility': true,
    'fieldName': 'state',
    'displayName': 'State' },
     {'visibility': true,
    'fieldName': 'country',
    'displayName': 'Country' }];
    this.transform(this.country);
    this.sameAsTaxAddress = this.sameAsTA;
    this.transform(this.addressObject['country']);

  }

    fieldChange(fieldType) {
        this.notify.emit({ 'address': this.addressObject, 'field': this.field });
        if (fieldType === 'country') {
            this.transform(this.addressObject['country']);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // only run when these properties are changed
        if (changes['country']) {
            if (this.mode !== 'Edit') {
                this.addressObject = Object.assign({}, {
                    'address1': '',
                    'address2': '',
                    'address3': '',
                    'state': '',
                    'city': '',
                    'zip': '',
                    'country': '',
                });
            }
        }
        if (changes['sameAsTA']) {
            if (this.taxAddressObject) {
                if (this.sameAsTA) {
                    console.log('reached here');
                    this.addressObject= this.taxAddressObject;
                    this.transform(this.addressObject['country']);
                } else {
                    // this.addressObject = {
                    //     'address1': '',
                    //     'address2': '',
                    //     'address3': '',
                    //     'state': '',
                    //     'city': '',
                    //     'zip': '',
                    //     'country': '',
                    // };
                    // this.transform('');
                }
            }
            console.log('Address Object 1', this.addressObject );
        }
    }
    taxAddressSameAsPersonalAddress(event) {
        if (event === true) {
            // console.log(this.taxAddressObject);
            // this.addressFormatObject = JSON.parse(JSON.stringify(this.taxAddressObject));
            // this.transform(this.addressFormatObject['country']);
            this.addressObjectcopy = JSON.parse(JSON.stringify(this.addressObject));
            this.sameAsTaxAddress = true;
            this.sameasPA.emit(true);
        } else {
            this.addressObject = JSON.parse(JSON.stringify(this.addressObjectcopy));
            this.transform(this.addressObject['country']);
            this.sameasPA.emit(false);
            this.sameAsTaxAddress = false;
        }
    }


}
